import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class ActivityService {

    constructor(
        private httpService: HttpService) { }
    //消费返现
    getConsumReturnCash() {
        var url = AppConfig.GetProdUrl()+ "/Activity/ConsumReturnCash";
        return this.httpService.get(url);
    }

}


// WEBPACK FOOTER //
// ./src/services/activity.service.ts